//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from "vuex";
import ImportSupplierPricesDialogWidget from "../Widgets/ImportSupplierPricesDialogWidget.vue";
import ImportDimensionsDialogWidget from "../Widgets/ImportDimensionsDialogWidget.vue";
import logger from "@/utils/logger";

export default {
  components: { ImportSupplierPricesDialogWidget, ImportDimensionsDialogWidget },
  data() {
    return {
      pagination: {
        rowsPerPage: 30,
        sortBy: "id",
        descending: true
      },
      columns: [
        {
          name: "id",
          align: "left",
          label: this.$t("productDiscount.id"),
          field: "id",
          style: "width: 300px",
          sortable: true
        },
        {
          name: "customerName",
          align: "left",
          label: this.$t("productDiscount.customer"),
          field: "customerName",
          sortable: true
        },

        {
          name: "productCateogryName",
          align: "left",
          label: this.$t("productDiscount.productCateogry"),
          field: "productCategoryName",
          sortable: true
        },

        {
          name: "discount",
          align: "right",
          label: this.$t("productDiscount.discount"),
          field: "discount",
          style: "width:210px",
          sortable: true
        }
      ],

      paginationPriceCalcultaion: {
        rowsPerPage: 30,
        sortBy: "id",
        descending: true
      },

      paginationSD: {
        rowsPerPage: 30,
        sortBy: "id",
        descending: true
      },

      columnsPriceCalculation: [
        {
          name: "id",
          align: "left",
          label: this.$t("productDiscount.id"),
          field: "id",
          style: "width: 100px",
          sortable: true
        },
        {
          name: "name",
          align: "left",
          label: "Navn",
          field: "name",
          style: "width: 300px",
          sortable: true
        },
        {
          name: "fullCostMarkup",
          align: "left",
          label: "Selvkost påslag (%)",
          field: "fullCostMarkup",
          style: "width: 300px",
          sortable: true
        },
        {
          name: "salesPriceMarkup",
          align: "left",
          label: "Utpris påslag (%)",
          field: "salesPriceMarkup",
          style: "width: 300px",
          sortable: true
        }
      ],

      columnsSD: [
        {
          name: "id",
          align: "left",
          label: this.$t("productDiscount.id"),
          field: "id",
          style: "width: 300px",
          sortable: true
        },
        {
          name: "supplierName",
          align: "left",
          label: this.$t("products.supplier"),
          field: "supplierName",
          sortable: true
        },

        {
          name: "productCateogryName",
          align: "left",
          label: this.$t("productDiscount.productCateogry"),
          field: "productCategoryName",
          sortable: true
        },

        {
          name: "discount",
          align: "right",
          label: this.$t("productDiscount.discount"),
          field: "discount",
          style: "width:210px",
          sortable: true
        }
      ],

      discountTab: "customerTab",
      filter: "",
      productDiscount: [],
      showAction: false,

      showNewPriceCaclulationDialog: false,
      newPriceDiscount: false,
      newPriceCalculation: false,
      selectedProductDiscount: {},
      discount: 0,
      id: 0,
      CustomerId: -1,
      ProductCatogoryId: -1,
      Customers: [],
      FilterCustomers: [],
      ProductCategory: [],
      FilterProductCategory: [],
      priceCalcultaion: [],
      supplierDiscount: [],
      showSDAction: false,
      newSupplierDiscount: false,
      selectedSupplierDiscount: {},
      sdId: 0,
      SupplierId: -1,
      Suppliers: [],
      FilterSuppliers: [],
      newLabel: "Ny kunderabatt",
      priceCalcultaionId: 0,
      priceCalcultaionFullCostMarkup: 0,
      priceCalcultaionSalesPriceMarkup: 0,
      priceCalcultaionName: '',
      isImportSupplierPricesDialogVisible: false,
      isImportDimensionsDialogVisible: false,
    };
  },
  async mounted() {
    await this.refresh();
    this.Customers = await this.getCustomers();
    this.FilterCustomers = await this.getCustomers();
    this.ProductCategory = await this.getProductCategory();
    this.FilterProductCategory = await this.getProductCategory();
    this.Suppliers = await this.getSuppliers();
    this.FilterSuppliers = await this.getSuppliers();
    this.priceCalcultaion = await this.getPriceCalcultaion();
  },
  computed: {
    ...mapState("main", ["warehouses", "locations"])
  },

  methods: {
    ...mapActions("main", [
      "postPriceCalculation",
      "postPriceCalculation",
      "putProductDiscount",
      "putPriceCalculation",
      "deleteProductDiscount",
      "deletePriceCalculation",
      "getProductDiscount",
      "getProductDiscounts",
      "getCustomers",
      "getProductCategory",
      "getPriceCalcultaion",
      "postSupplierDiscount",
      "putSupplierDiscount",
      "deleteSupplierDiscount",
      "getSupplierDiscount",
      "getSupplierDiscounts",
      "getSuppliers"
    ]),

    openImportSupplierPricesDialog() {
      this.isImportSupplierPricesDialogVisible = true;
    },


    openImportDimensionsDialog(){
      this.isImportDimensionsDialogVisible = true;
    },

    tabChange() {
      if (this.discountTab == "customerTab") {
        this.newLabel = "Ny kunderabatt";
      } else if (this.discountTab == "supplierTab") {
        this.newLabel = "Ny leverandørrabatt";
      } else if (this.discountTab == "priceCalulationTab") {
        this.newLabel = "Ny kalkyle";
      }
    },

    onRowClick(evt, row) {
      this.resetForm();
      this.newPriceDiscount = false;
      this.selectedProductDiscount = row;
      this.id = row.id;
      this.CustomerId = row.customerId;
      this.ProductCatogoryId = row.productCategoryId;
      this.discount = row.discount;
      this.showAction = true;
    },

    onSDRowClick(evt, row) {
      this.resetForm();
      this.newSupplierDiscount = false;
      this.selectedSupplierDiscount = row;
      this.sdId = row.id;
      this.SupplierId = row.supplierId;
      this.ProductCatogoryId = row.productCategoryId;
      this.discount = row.discount;
      this.showSDAction = true;
    },

    onPriceCaclulationRowClick(evt, row) {
      this.resetForm();
      this.priceCalcultaionId = row.id;
      this.priceCalcultaionFullCostMarkup = row.fullCostMarkup;
      this.priceCalcultaionSalesPriceMarkup = row.salesPriceMarkup;
      this.priceCalcultaionName = row.name
      this.newPriceCalculation = false;
      this.showNewPriceCaclulationDialog = true;
    },

    resetForm() {
      this.discount = 0;
      this.id = 0;
      this.newPriceDiscount = false;
      this.newPriceCalculation = false;
      this.ProductCatogoryId = -1;
      this.CustomerId = -1;
      this.selectedProductDiscount = {};
      this.sdId = 0;
      this.newSupplierDiscount = false;
      this.selectedSupplierDiscount = {};
      this.SupplierId = -1;
      this.priceCalcultaionId = 0;
      this.priceCalcultaionFullCostMarkup = 0;
      this.priceCalcultaionSalesPriceMarkup = 0;
      this.priceCalcultaionName = ''
    },

    newDiscount() {
      this.resetForm();

      // sjekk om det er kunde eller leverandør
      if (this.discountTab == "customerTab") {
        this.showAction = true;
        this.newPriceDiscount = true;
      } else if (this.discountTab == "supplierTab") {
        this.showSDAction = true;
        this.newSupplierDiscount = true;
      } else if (this.discountTab == "priceCalulationTab") {
        this.showNewPriceCaclulationDialog = true;
        this.newPriceCalculation = true;
      }
    },

    async refresh() {
      this.productDiscount = [];
      this.supplierDiscount = [];
      this.priceCalcultaion = [];
      const notif = this.$q.notify({
        type: "ongoing",
        message: "Laster data..."
      });

      this.productDiscount = await this.getProductDiscounts();
      this.supplierDiscount = await this.getSupplierDiscounts();
      this.priceCalcultaion = await this.getPriceCalcultaion();

      setTimeout(() => {
        notif();
      }, 500);
    },

    async delPriceCalculation() {
      var res = await this.deletePriceCalculation(this.priceCalcultaionId);
      this.showNewPriceCaclulationDialog = false;
      if (res == "true") {
        await this.refresh();
      } else {
        this.$q.notify({
          type: "negative",
          message: this.$t("common.errorSave")
        });
      }
    },

    async delProductDiscount() {
      var res = await this.deleteProductDiscount(this.id);

      if (res == "true") {
        this.showAction = false;
        await this.refresh();
      } else {
        this.$q.notify({
          type: "negative",
          message: this.$t("common.errorSave")
        });
      }
    },

    async savePriceCalculation() {
      this.showNewPriceCaclulationDialog = false;

      if (this.newPriceCalculation) {
        var postDto = {};
        postDto.fullCostMarkup = parseFloat(
          this.priceCalcultaionFullCostMarkup
        );
        postDto.salesPriceMarkup = parseFloat(
          this.priceCalcultaionSalesPriceMarkup
        );

        postDto.name = this.priceCalcultaionName;

        try {
          var createdDto = await this.postPriceCalculation(postDto);
          if (createdDto && createdDto.id > 0) {
            await this.refresh();

            this.$q.notify({
              type: "positive",
              message: this.$t("common.saveOk")
            });
          } else {
            this.$q.notify({
              type: "negative",
              message: this.$t("common.errorSave")
            });
          }
        } catch (err) {
          logger.log(err.message);
          this.$q.notify({
            type: "negative",
            message: `${this.$t(
              "common.errorSave"
            )}. ${this.$utils.GetErrorMessage(err)}`
          });
        }
      } else {
        var putDto = {};
        putDto.id = this.priceCalcultaionId;
        putDto.fullCostMarkup = parseFloat(this.priceCalcultaionFullCostMarkup);
        putDto.salesPriceMarkup = parseFloat(
          this.priceCalcultaionSalesPriceMarkup
        );

        putDto.name = this.priceCalcultaionName;

        try {
          var success = await this.putPriceCalculation(putDto);

          if (success) {
            await this.refresh();
            this.$q.notify({
              type: "positive",
              message: this.$t("common.saveOk")
            });
          } else {
            this.$q.notify({
              type: "negative",
              message: this.$t("common.errorSave")
            });
          }
        } catch (err) {
          logger.log(err.message);
          this.$q.notify({
            type: "negative",
            message: this.$t("common.errorSave")
          });
        }
      }

      this.resetForm();
    },

    async saveProductDiscount() {
      this.showAction = false;

      try {
        this.productDiscount.forEach(element => {
          if (
            this.newPriceDiscount &&
            element.customerId == this.CustomerId &&
            element.productCategoryId == this.ProductCatogoryId
          ) {
            this.$q.notify({
              type: "negative",
              message: this.$t("productDiscount.exist")
            });
            throw "produktrabatt finnes";
          }
        });
      } catch (err) {
        return false;
      }

      if (this.newPriceDiscount) {
        var postProductDiscount = {};
        postProductDiscount.customerId = this.CustomerId;
        postProductDiscount.productCategoryId = this.ProductCatogoryId;
        postProductDiscount.discount = parseFloat(this.discount);

        try {
          var createdDto = await this.postProductDiscount(postProductDiscount);
          if (createdDto && createdDto.id > 0) {
            await this.refresh();

            this.$q.notify({
              type: "positive",
              message: this.$t("common.saveOk")
            });
          } else {
            this.$q.notify({
              type: "negative",
              message: this.$t("common.errorSave")
            });
          }
        } catch (err) {
          logger.log(err.message);
          this.$q.notify({
            type: "negative",
            message: `${this.$t(
              "common.errorSave"
            )}. ${this.$utils.GetErrorMessage(err)}`
          });
        }
      } else {
        var putProductDiscount = {};
        putProductDiscount.customerId = this.CustomerId;
        putProductDiscount.id = this.id;
        putProductDiscount.productCategoryId = this.ProductCatogoryId;
        putProductDiscount.discount = parseFloat(this.discount);

        try {
          var success = await this.putProductDiscount(putProductDiscount);

          if (success) {
            await this.refresh();
            this.$q.notify({
              type: "positive",
              message: this.$t("common.saveOk")
            });
          } else {
            this.$q.notify({
              type: "negative",
              message: this.$t("common.errorSave")
            });
          }
        } catch (err) {
          logger.log(err.message);
          this.$q.notify({
            type: "negative",
            message: this.$t("common.errorSave")
          });
        }
      }
    },

    getCustomerFilter(val, update) {
      if (!this.Customers) {
        update();
        return;
      }
      update(() => {
        this.Customers = this.FilterCustomers.filter(
          p => p.name.toLowerCase().indexOf(val.toLowerCase()) > -1
        );
      });
    },

    getSupplierFilter(val, update) {
      if (!this.Supplier) {
        update();
        return;
      }
      update(() => {
        this.Suppliers = this.FilterSuppliers.filter(
          p => p.name.toLowerCase().indexOf(val.toLowerCase()) > -1
        );
      });
    },

    async delSupplierDiscount() {
      var res = await this.deleteSupplierDiscount(this.sdId);

      if (res == "true") {
        this.showSDAction = false;
        await this.refresh();
      } else {
        this.$q.notify({
          type: "negative",
          message: this.$t("common.errorSave")
        });
      }
    },

    async saveSupplierDiscount() {
      this.showSDAction = false;

      try {
        this.supplierDiscount.forEach(element => {
          if (
            this.newSupplierDiscount &&
            element.supplierId == this.SupplierId &&
            element.productCategoryId == this.ProductCatogoryId
          ) {
            this.$q.notify({
              type: "negative",
              message: "leverandørrabatt finnes allerede for varegruppen"
            });
            throw "leverandørrabatt finnes";
          }
        });
      } catch (err) {
        return false;
      }

      if (this.newSupplierDiscount) {
        var postSupplierDiscount = {};
        postSupplierDiscount.supplierId = this.SupplierId;
        postSupplierDiscount.productCategoryId = this.ProductCatogoryId;
        postSupplierDiscount.discount = parseFloat(this.discount);

        try {
          var createdDto = await this.postSupplierDiscount(
            postSupplierDiscount
          );
          if (createdDto && createdDto.id > 0) {
            await this.refresh();
            this.$q.notify({
              type: "positive",
              message: this.$t("common.saveOk")
            });
          } else {
            this.$q.notify({
              type: "negative",
              message: this.$t("common.errorSave")
            });
          }
        } catch (err) {
          logger.log(err.message);
          this.$q.notify({
            type: "negative",
            message: this.$t("common.errorSave")
          });
        }
      } else {
        var putSupplierDiscount = {};
        putSupplierDiscount.supplierId = this.SupplierId;
        putSupplierDiscount.id = this.sdId; //??
        putSupplierDiscount.productCategoryId = this.ProductCatogoryId;
        putSupplierDiscount.discount = parseFloat(this.discount);

        try {
          var success = await this.putSupplierDiscount(putSupplierDiscount);

          if (success) {
            await this.refresh();
            this.$q.notify({
              type: "positive",
              message: this.$t("common.saveOk")
            });
          } else {
            this.$q.notify({
              type: "negative",
              message: this.$t("common.errorSave")
            });
          }
        } catch (err) {
          logger.log(err.message);
          this.$q.notify({
            type: "negative",
            message: `${this.$t(
              "common.errorSave"
            )}. ${this.$utils.GetErrorMessage(err)}`
          });
        }
      }
    },

    getProductCategoryFilter(val, update) {
      if (!this.ProductCategory) {
        update();
        return;
      }
      update(() => {
        this.ProductCategory = this.FilterProductCategory.filter(
          w =>
            !w.isDeleted && w.name.toLowerCase().indexOf(val.toLowerCase()) > -1
        );
      });
    }
  }
};
